import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './alert.scss';

export default ({
    isOpen,
    toggle,
    title,
    alertType,
    content,
    link,
    postType,
    callBackAlert,
    inventoryCallBackAlert,
    postCallBackAlert,
    size,
    styleClass
}) => {
  let history = useHistory();

  const redirectLink = (link) => {
    if (link === 'manageAccount') {
      window.location.reload(false);
    } else {
      if (link) {
        if (postType) {
          history.push({
            pathname: link,
            // search: '?postType=' + postType.toString(),
          })
        }
        else {
          history.push(link);
        }
      }
    }
    toggle(!isOpen)


    if (alertType === "success") {
      callBackAlert("success")
    }
    if ((alertType && alertType.includes("Checkout")) && !link) {
      callBackAlert()
    }

    if (alertType === "editDeleteRecurrence") {
      callBackAlert("editDeleteRecurrence")
    }

    if (alertType === "acknowledge") {
      callBackAlert("acknowledge")
    }
    if (alertType === "cardValidated") {
      callBackAlert("cardValidated")
    }
    if (alertType === "buyerCardValidated") {
      callBackAlert("buyerCardValidated")
    }
    if (alertType === "taxExamption") {
      callBackAlert()
    }
    if (alertType === "taxExamptionFailure" || alertType === "failure") {
      callBackAlert('failure')
    }
    if (alertType === "confirmPassword") {
      callBackAlert('confirmPassword')
    }
    if (alertType === "load") {
      callBackAlert()
    }
    if (title === "AddUser") {
      callBackAlert("AddUser")
    }
    if (title === "manageAccount") {
      callBackAlert("manageAccount")
    }
    if (alertType === "checkout" && !link) {
      callBackAlert("")
    }
    if (alertType === "Repost") {
      callBackAlert("Repost")
    }
    if (alertType === "createGroup") {
      callBackAlert("createGroup")
    }
    if (alertType === "MyOfferInventoryBids") {
      inventoryCallBackAlert()
    }
    if (alertType === "MyOfferPostBids") {
      postCallBackAlert()
    }
    if (alertType === "MyInventories") {
      inventoryCallBackAlert()
    }
    if (alertType === "MyPostLoad") {
      postCallBackAlert()
    }
    if (alertType === "createRegistrationPromoCode" || alertType === "createCheckoutPromoCode") {
      callBackAlert()
    }
    if (alertType === "reuploadBol" || alertType === "escalatedClaim") {
      callBackAlert()
    }
    if (alertType === "adminAddEditLocation" || alertType === 'adminSubUserLocation' || alertType === 'adminNewCustomerInvite') {
      callBackAlert()
    }
    if (alertType === "achVerficationModal") {
      callBackAlert()
    }
  }
  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        size={size}
        className={`${styleClass} alertModal`}>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              redirectLink(link)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            <div>
              {title === "AddUser" || title === "manageAccount" && <h3 className='modal-title'></h3>}
              {title !== "AddUser" && title !== "manageAccount" && <h3 className='modal-title'>{title}</h3>}
            </div>
            <div className='modal-content'>
              <p>{content}</p>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
            <Button
              type='app-green-button submitBtn'
              handleClick={() => {
                redirectLink(link)
              }}>
              OK
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
